import { useContext } from 'react';
import StyledChatMessageBubble from '../../styles/StyledChatMessageBubble';
import AppContext from '../../contexts/AppContext';
import AppContextType from '../../types/AppContextType';

interface ChatMessageBubbleProps {
  fromUser: boolean;
  children: React.ReactNode;
}

const ChatMessageBubble = ({ fromUser, children }: ChatMessageBubbleProps) => {
  const { configuration } = useContext<AppContextType>(AppContext);

  if (!configuration) return <></>;
  
  return (
    <StyledChatMessageBubble 
      $fromUser={fromUser}
      $backgroundColor={configuration.theme_color}
    >
      {children}
    </StyledChatMessageBubble>
  );
};

export default ChatMessageBubble;